import { Grid, Popover, Steps } from 'antd';
import React from 'react';
import { CONFIG } from '../constants';

const { useBreakpoint } = Grid;
const stepStyle = {
  boxShadow: '0px -1px 0 0 #e8e8e8 inset'
};

const StepperSolicitud = ({ current, steps }) => {
  const screens = useBreakpoint();
  let stepProps;
  if (screens.md === false) {
    stepProps = {};
  } else if (screens.md === true) {
    stepProps = { type: 'navigation' };
  }

  const customDot = (item, index) => {
    if (screens.md === true) {
      return null;
    }
    return (
      <Popover content={<span>{item.description}</span>}>
        <div
          style={{
            width: ' 24px',
            height: ' 24px',
            marginTop: 0,
            marginBottom: 0,
            marginInline: ' 0 8px',
            fontSize: '12px',
            lineHeight: ' 24px',
            textAlign: 'center',
            borderRadius: ' 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            verticalAlign: 'top',
            border: '1px solid transparent',
            transition: 'background-color 0.3s,border-color 0.3s',
            backgroundColor:
              index <= current ? CONFIG.COLOR_PRIMARY : 'inherit',
            // background: 'inherit',
            borderColor: index <= current ? CONFIG.COLOR_PRIMARY : 'inherit',
            color: index <= current ? 'white' : CONFIG.COLOR_PRIMARY
          }}
        >
          {index + 1}
        </div>
      </Popover>
    );
  };
  return (
    <>
      {(screens.md === true || screens.md === false) && (
        <Steps
          {...stepProps}
          style={screens.md === true ? stepStyle : { width: '100%' }}
          size="small"
          current={current}
          responsive={false}
          items={steps.slice(0, 6).map((item, index) => ({
            icon: customDot(item, index, current),
            title: screens.md === true && item.title,
            description: screens.md === true && item.description
          }))}
        />
      )}
    </>
  );
};

export default StepperSolicitud;
